import { render, staticRenderFns } from "./WeeklyReportViewLogs.vue?vue&type=template&id=63c105d0"
import script from "./WeeklyReportViewLogs.vue?vue&type=script&lang=js"
export * from "./WeeklyReportViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports